import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import './styles.css'
import './reference-theme.css'
import './vip.css'

if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    const serviceWorkerUrl = `${import.meta.env.BASE_URL}sw.js?v=${encodeURIComponent(import.meta.env.VITE_BUILD_VERSION)}`
    void navigator.serviceWorker.register(serviceWorkerUrl).catch(() => {
      // A static production build remains usable when service workers are unavailable.
    })
  })
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
)
